import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { useRef } from "react";

export const FindResumes = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
}